import React, { useContext } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Box from '@material-ui/core/Box';
import FiltersContext from '../../contexts/FiltersContext';

function ToggleRaceEthnicity() {
  const { childRace, setChildRace } = useContext(FiltersContext);
  const races = ['White', 'Black', 'Hispanic', 'Asian', 'AINA', 'NHPI', 'Multiracial', 'Other'];

  const handleChange = (event) => {
    setChildRace(event.target.value);
  };

  return (
    <Box displayPrint="none">
      <FormControl component="fieldset">
        <FormLabel component="legend">Overlay Child Race/Ethnicity %</FormLabel>
        <RadioGroup aria-label="toggle by" name="toggleby" value={childRace} onChange={handleChange}>
          <FormControlLabel value="All" control={<Radio />} label="None" />
          {races.map((r) => (
            <FormControlLabel key={r} value={r} control={<Radio />} label={r} />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
}

export default ToggleRaceEthnicity;
